module.exports = __webpack_public_path__ + "odinstatic/media/create_demand.323e9c1e.svg";